module.exports = __webpack_public_path__ + "img/demographics-map@2x.73dbcca5.png";